import { createContext } from "react";
import { useStickyState } from "../hooks/stickyState";

const CardContext = createContext({
    cards: [],
    addCard : ( card ) => { console.log('do a thing!') },
    removeCard : ( card ) => { console.log('do a thing!') },
    editCard : ( card ) => {},
    clearCompletedItems : () => {}
})

const CardContextProvider = ({ children }) => {
    const [ cards, setCards ] = useStickyState( [ { img : 'https://placebear.com/900/700', link : '#', title : 'Title', text : 'Blah blah', type : '' } ], 'jd_cards');

    const addCard = ( newCard ) => {
        console.log(newCard)
        setCards([ ...cards, newCard]);
    }

    const removeCard = ( index ) => {
        setCards( (items) => {
            return [...items.slice(0, index), ...items.slice(1 + index)];
        });
    }

    // TODO: This is buggy!
    const updateCard = ( card ) => {
        const { index }  = card

        setCards( (items) => {
            return [...items.slice(0, index), card, ...items.slice(1 + index)];
        });
    }

    // TODO: This is buggy!
    const editCard = ( index, card ) => {
        setCards( (items) => {
            return [...items.slice(0, index), card, ...items.slice(1 + index)];
        });
    }

    return (
        <CardContext.Provider value={{
            cards, addCard, removeCard, editCard, updateCard
        }}>
            {children}
        </CardContext.Provider>
    )
}

export default CardContext;
export { CardContextProvider };